import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Logger } from 'angular2-logger/core';
import { Ng4FilesService, Ng4FilesConfig, Ng4FilesStatus, Ng4FilesSelected } from 'angular4-files-upload';

import { SharedService } from '../../../shared/shared.service';
import { UserService } from '../user.service';
import { ScheduleService } from '../../schedule/schedule.service';
import { NgxSpinnerService } from 'ngx-spinner';
import {DashboardService} from '../../../dashboard/dashboard.service';



//  Jquery imports
declare var jquery: any;
declare var $: any;

@Component({
	selector: 'app-user-edit',
	templateUrl: './user-edit.component.html',
	styleUrls: ['../../admin/admin.component.scss'],
	providers: [ScheduleService]
})

export class UserEditComponent implements OnInit {
	public schedule_user: any;
	//public load: boolean;
	//public load_avatar: boolean;
	public form: FormGroup;
	public form2: FormGroup;
	public user_id: string;
	public user_email: string;
	public shop: any = {};
	public shop_list: any = [];
	public status_list: any = [];
	public time_zones: any = [];
	//public m_load: boolean;
	public schedule_list: any = [];
	public schedule: any = {};
	public day_helper = { 1: 'monday', 2: 'tuesday', 3: 'wednesday', 4: 'thursday', 5: 'friday', 6: 'saturday', 7: 'sunday' };
	public selectedFiles;
	public base64textString: string;
	public img_src: string;

	constructor(
		private _userService: UserService,
		private _sharedService: SharedService,
		private _param: ActivatedRoute,
		private _router: Router,
		public toastr: ToastsManager,
		private logger: Logger,
		private fb: FormBuilder,
		private activatedRoute: ActivatedRoute,
		private ng4FilesService: Ng4FilesService,
		private scheduleService: ScheduleService,
		private spinner: NgxSpinnerService,
		private _dashboardService : DashboardService
		
			) {

		this.schedule.monday = [];
		this.schedule.tuesday = [];
		this.schedule.wednesday = [];
		this.schedule.thursday = [];
		this.schedule.friday = [];
		this.schedule.saturday = [];
		this.schedule.sunday = [];

		// subscribe to router event
		this.activatedRoute.params.subscribe(params => {
			this.user_id = params['id'];
		});

		this.form = this.fb.group({
			id: [this.user_id],
			firstname: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(60)]],
			lastname: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(60)]],
			role: ['', [Validators.required]],
			suspended: ['', [Validators.required]],
			email: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$')]],
			schedule: ['', [Validators.required]],
			shop:[''],
			time_zone:['']
		});

		this.form2 = this.fb.group({
			filename: ['', [Validators.required]]
		});

		console.log(this.form)
	}

	ngOnInit() {
		this.ng4FilesService.addConfig(this.testConfig);
		this.loadUserData();

		let data = {
			auth_token: this._sharedService.getCookie("auth_token"),
            view : 'user'
		};

		this._userService.getShop(data).subscribe(
			data => {
				let valuei= 0;
				for (let i = 0; i < data.data.length; i++) {
					this.shop_list[i] = 
					{'id': data.data[i].id, 'itemName':data.data[i].fullname};
					
					valuei = i;  
				}
			},
			error => { //server error
				//this.load = false;
				this.spinner.hide();
				this.toastr.error('Ha ocurrido un error, inténtalo de nuevo', 'Error');
				this.logger.log(error);
			}
		);
		
		console.log('time', this._userService.getTimeZoneList(data));

		this._userService.getTimeZoneList(data).subscribe(
			
			data => {
				let valuei= 0;
				for (let i = 0; i < data.data.length; i++) {
					this.time_zones[i] = {'name': data.data[i]};
					valuei = i;  
				}
			},
			error => { //server error
				//this.load = false;
				this.spinner.hide();
				this.toastr.error('Ha ocurrido un error, inténtalo de nuevo', 'Error');
				this.logger.log(error);
			}
		);
		
	}
    

	onEdit() {
		//this.load = true;
		this.spinner.show();
		//this.form.value.email = this.user_email;
		this.form.value.auth_token = this._sharedService.getCookie('auth_token'); // get cookie
		this.form.value.suspended = parseInt(this.form.value.suspended); // normalize
		this.form.value.role = parseInt(this.form.value.role); // normalize
		this.form.value.schedule = parseInt(this.form.value.schedule); // normalize
       // this.form.value.shop = parseInt(this.form.value.shop);
		//this.form.value.id_status = parseInt(this.form.value.id_status);
		//this.logger.log(this.form.value);
		console.log('editando usuario');
		console.log(this.form.value);
		this._userService.edituser(this.form.value).subscribe(
			data => {
				if (data.status) {
					if (this.schedule_user != null) {
						let param = {
							auth_token: this._sharedService.getCookie('auth_token'),
							user_schedule_id: this.schedule_user.id_user_schedule,
							schedule_id: this.form.value.schedule
						}
						this._userService.updateUserSchedule(param).subscribe(
							res => {
								this.logger.log(res.status);
								console.log("Se asocio el horario al usuario correctamente");
								this.toastr.success('El usuario ha sido editado!', '¡Éxito!');
								this.onCancel();
								//this.load = false;
								this.spinner.hide();
							}, error => {
								//this.load = false;
								this.spinner.hide();
								this.toastr.error("Ocurrió un error al actualizar el horario.", 'Error');
							}

						);
					} else {
						let param = {
							auth_token: this._sharedService.getCookie('auth_token'),
							user_id: this.form.value.id,
							schedule_ids: [this.form.value.schedule]
						}
						this._userService.saveUserSchedule(param).subscribe(
							res => {
								//this.load = false;
								this.spinner.hide();
								this.logger.log(res.status);
								this.toastr.success('El usuario ha sido editado!', '¡Éxito!');
								console.log("Se asocio el horario al usuario correctamente");
								this.onCancel();
							}, error => {
								//this.load = false;
								this.spinner.hide();
								this.toastr.error("Ocurrió un error al actualizar el horario.", 'Error');
							}
						);
					}
					//revisa si hay pendientes en la cola y las asigna
					let dataUpdatePendin = {
						user:this.form.value.id,
						role_id:1,
						auth_token: this._sharedService.getCookie('auth_token')
					};
					console.log(dataUpdatePendin)
				
					this._dashboardService.roomsPending(dataUpdatePendin).subscribe(
					);

				} else {
					this.toastr.error(data.message, 'Error');
				}

				
			},
			error => {
				//this.load = false;
				this.spinner.hide();
				this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
				this.logger.log(error);
			}
		);
	}

	

	private testConfig: Ng4FilesConfig = {
		acceptExtensions: ['jpg', 'png', 'gif'],
		maxFilesCount: 1,
		maxFileSize: 512000,
		totalFilesSize: 512000
	};

	filesSelect(selectedFiles: Ng4FilesSelected): void {

		if (selectedFiles.status !== Ng4FilesStatus.STATUS_SUCCESS) {

			this.toastr.error("El archivo seleccionado no está permitido", 'Error');

		} else {

			let name = Array.from(selectedFiles.files).map(file => file.name);
			this.selectedFiles = selectedFiles;
			this.logger.log(this.selectedFiles);
			this.form2.setValue({
				filename: name[0]
			});
		}

	}

	onEditAvatar() {
		//this.load_avatar = true;
		//this.load = true;
		this.spinner.show();

		let data = {
			auth_token: this._sharedService.getCookie('auth_token'), // get cookie
			user_id: this.form.value.id,
			file: this.selectedFiles.files[0]
		}

		this._userService.uploadfiles(data).subscribe(

			data => {
				// respuesta
				if (data.status) {
					this.toastr.success('La imagen ha sido guardada!', '¡Éxito!');
					this.img_src = data.data.url;
					//this.load = false;
				} else {
					this.toastr.error(data.message, 'Error');
					this.logger.log(data.message);
				}
				//this.load_avatar = false;
				this.spinner.hide();
			},
			error => {
				//this.load_avatar = false;
				this.spinner.hide();
				this.logger.log(error);
			});
	}

	onDetails(id: number) {

		$('#Details').modal('toggle'); // open modal

		//this.m_load = true;
		this.spinner.show();

		let data = {
			auth_token: this._sharedService.getCookie('auth_token'),
			id: id
		}

		this._userService.getSchedule(data).subscribe(
			data => {
				if (data.status) {
					this.logger.log(data.data);
					this.logger.log("schedule data received");
					this.schedule.name = data.data.name

					for (let i = 0; i < data.data.schedules.length; i++) {
						let aux_day = this.day_helper[data.data.schedules[i].day_week];
						this.schedule[aux_day] = data.data.schedules[i].shift;
					}

				} else {
					this.toastr.error(data.message, 'Error');
				}
				//this.m_load = false;
				this.spinner.hide();
			},
			error => {
				this.toastr.error('Ocurrió un error, inténtalo de nuevo.', 'Error');
				//this.m_load = false;
				this.spinner.hide();
				this.logger.log(error);
			}
		);

	}


	loadUserData() {
		// this.load_avatar = true;
		// this.load = true;
		this.spinner.show();
		let data = {
			auth_token: this._sharedService.getCookie('auth_token'), // get cookie
			id: this.user_id
		};

		// initialized the user
		this._userService.getuser(data).subscribe(
			data => {
				//this.load_avatar = false;

				this.logger.log(data);
				if (data.status) {
					let param = {
						auth_token: this._sharedService.getCookie('auth_token'), // get cookie
						id_agent: this.user_id,
						type: 1 //solo el horario regular
					}
					this.scheduleService.getSchedulesByIdAgentAndType(param).subscribe(
						resp => {
							if (resp.status) {
								this.schedule_user = resp.data[0];
								let sche = this.schedule_user != null ? this.schedule_user.id : null;
								this.form.setValue({
									id: data.data.user.id,
									firstname: data.data.user.firstname,
									lastname: data.data.user.lastname,
									role: data.data.user.role_id,
									suspended: data.data.user.suspended,
									email: data.data.user.email,
									schedule: sche,
									shop: data.data.tienda,
									time_zone: data.data.user.time_zone
								});
							} else {
								this.toastr.error(resp.message, 'Error');
							}
							//this.load = false;
							this.spinner.hide();
						}, error => {
							//this.load = false;
							this.spinner.hide();
							this.toastr.error(error.message, 'Error');
						}
					);
					this.user_email = data.data.email;
					this.img_src = data.data.image;

				} else {
					//this.load = false;
					this.toastr.error(data.message, 'Error');
					this.spinner.hide();
				}
			
			},

			
			error => {
				//this.load = false;
				//this.load_avatar = false;
				this.spinner.hide();
				this.toastr.error('Ocurrió un error, inténtalo de nuevo.', 'Error');
				this.logger.log(error);

			}
		);

		//initializes the schedule list.

		let data2 = {
			auth_token: this._sharedService.getCookie("auth_token"),
			type: 1 //Solo horario regulares
		};

		this._userService.getScheduleListByType(data2).subscribe(
			data => {
				//this.load = false;
				this.spinner.hide();
				if (data.status) { //success
					this.schedule_list = data.data; // schedule list
				} else { // API error
					this.toastr.error(data.message, 'Error');
				}

			},
			error => { //server error
				//this.load = false;
				this.spinner.hide();
				this.toastr.error('Ocurrió un error, inténtalo de nuevo.', 'Error');
				this.logger.log(error);
			}
		);
	}

	onCancel() {
		return this._router.navigate(['./admin/users/list']);
	}

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/user/user-edit/user-edit.component.ts